export default {
  text: 'Summer',
  thumbnail:
    'https://vastreach.com/static_assets/email/thumnails/Summer_email.jpg',
  snippets: {
    Button: {
      icon: 'RadioButton',
      text: 'Button',
      editor: 'button',
      html: '<!-- Dynamic WYSIWYG Content --><div style="max-width: 600px;margin: 0 auto 0;padding: 10px 0;text-align: center;background: transparent;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;"><p style="text-align: center;margin:0;"><a data-button-text="Start now" data-button-url="https://www.vastreach.com" data-button-color="#ffffff" data-button-background-color="#00bfaf" href="#" target="_blank"><button style="color: #ffffff; background-color: #00bfaf;border: 0; padding: 15px 25px; margin: 0; border-radius: 0.3rem; cursor: pointer;"><strong>Start Now</strong></button></a></p></div><!-- End of Dynamic WYSIWYG Content -->',
    },
    Social: {
      icon: 'Share',
      text: 'Social',
      editor: 'social-media',
      html: '<!-- Dynamic WYSIWYG Content --><table style="margin: 0 auto;background: transparent;" border="0" cellpadding="0" cellspacing="0" align="center"><tr><td width="600" align="center"><table style="margin: 20px 0 20px 0;"><tr><td align="center"> <a data-social-media="facebook" href="https://www.facebook.com/" target="_blank"><img src="https://vastreach.com/static_assets/facebook.png" border="0" style="background-color: #00bfaf; padding: 4px; border-radius:28px;" /></a> </td><td align="center"> <a data-social-media="instagram" href="https://www.instagram.com/" target="_blank"><img src="https://vastreach.com/static_assets/instagram.png" border="0" style="background-color: #00bfaf;padding: 4px; border-radius:28px;" /></a> </td><td align="center"> <a data-social-media="twitter" href="https://twitter.com/" target="_blank"><img src="https://vastreach.com/static_assets/twitter.png" border="0" style="background-color: #00bfaf;padding: 4px; border-radius:28px;" /></a> </td></tr></table></td></tr></table><!-- End of Dynamic WYSIWYG Content -->',
    },
    Paragraph: {
      icon: 'Notes',
      text: 'Paragraph',
      editor: 'wysiwyg',
      html: `<!-- Dynamic WYSIWYG Content --><div style="max-width: 600px;margin: 0 auto 0;padding: 10px 20px;text-align: center;background: transparent;"> <span style="font-size: medium;color:#969696;padding: 0;margin:0;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">We have over 40 Hot Tubs & Swim Spas on Display from Major Brands and Everything Must Go! </span></div><!-- End of Dynamic WYSIWYG Content -->`,
    },
    'Image Banner + Text': {
      icon: 'Satellite',
      text: 'Image Banner + Text',
      editor: 'wysiwyg',
      html: '<!-- Dynamic WYSIWYG Content --><table style="width: 100%;max-width: 600px;margin: 0 auto;padding: 0;text-align: center;background: transparent;"><tr><td><tr><td valign="middle" style="background-image: url(https://vastreach.com/static_assets/email/summer_v1/text-bg.jpg);background-position: center center !important;background-size: cover !important;text-align: center;"><table border="0" cellpadding="0" cellspacing="0" width="100%" style="border-spacing: 0;"><tr><td valign="middle" style="text-align: center;padding: 40px;"><p style="font-size: 16px;font-weight: 500;line-height: 20px; color: #ffffff;padding: 0 20px 0 20px;margin: 0;">Optional text box to provide more details about your summer product, service or promotion. If the additional text isn’t needed, just delete it.</p></td></tr></table></td></tr></td></tr></table><!-- End of Dynamic WYSIWYG Content -->',
    },
  },
  value: `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">
<html xmlns="http://www.w3.org/1999/xhtml" style="width: 100%;height: 100%;margin: 0;padding: 0;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">

<head>
    <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
    <meta name="viewport" content="width=device-width"/>
	<meta class="vastreach-theme" data-vast-theme="summerv1"/>
</head>	

<body align="center" style="margin: 0;padding: 0;background-color: #ffffff;">
  <div class="background" style="background: #ffffff;">
    <div class="foreground" style="max-width: 600px;background: #ffffff;">
		<!-- Wrapper -->
		<table style="max-width: 600px;margin: 0 auto;padding: 0;text-align: center;border-spacing: 0;">
			<tr>	
				<td class="vastreach-sections" data-vast-editor="img-picker" style="margin: 0;padding: 0;">
					<!-- Dynamic WYSIWYG Content -->
					<div style="max-width: 600px;margin: 0 auto;padding: 0;text-align: center;background: transparent;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">  				
						<img src="https://vastreach.com/static_assets/email/summer_v1/banner.jpg" alt="summer banner" style="max-width: 100%;margin: 0 auto;display: block;">
					</div> 							
					<!-- End of Dynamic WYSIWYG Content -->
				</td>	
			</tr>

			<tr>
				<td class="vastreach-sections" data-vast-editor="img-picker" style="margin: 0;padding: 0;">
					<!-- Dynamic WYSIWYG Content -->
					<div style="max-width: 600px;margin: 0 auto;padding: 10px 0;text-align: center;background: transparent;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">				
						<img src="https://vastreach.com/static_assets/email/summer_v1/beta-logo.png" alt="logo" style="width: 100%;max-width: 200px;margin: 0 auto;">
					</div> 							
					<!-- End of Dynamic WYSIWYG Content -->
				</td>	
			</tr>

			<tr>
				<td class="vastreach-sections" data-vast-editor="paragraph" align="left">
					<!-- Dynamic WYSIWYG Content -->
					<div style="max-width: 600px;margin: 0 auto;padding: 10px 0;text-align: center;background: transparent;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">			
						<h1 style="margin: 0;"><span style="font-size: xx-large;font-family: Arial, Helvetica, sans-serif;">Product Promotion or Sale</span></h1>
					</div> 				
					<!-- End of Dynamic WYSIWYG Content -->
				</td>
			</tr>

			<tr>
				<td class="vastreach-sections" data-vast-editor="paragraph">
					<!-- Dynamic WYSIWYG Content -->
					<div style="max-width: 600px;margin: 0 auto;padding: 10px 0;text-align: center;background: transparent;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">			
						<hr>
					</div> 				
					<!-- End of Dynamic WYSIWYG Content -->
				</td>									
			</tr>		
		
			<tr>
				<td class="vastreach-sections" data-vast-editor="paragraph">
					<!-- Dynamic WYSIWYG Content -->
					<div style="max-width: 600px;margin: 0 auto 0;padding: 10px 20px;text-align: center;background: transparent;">        
						<span style="font-size: medium;color: #969696;padding: 0;margin:0;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">Summer means warm weather, vacations and fun in the sun! At [name of company], Summer means [a new product line, new services or some current promotion].</span>
					</div>			
					<!-- End of Dynamic WYSIWYG Content -->
				</td>	
			</tr>	

			<tr>
				<td class="vastreach-sections" data-vast-editor="paragraph">	
					<!-- Dynamic WYSIWYG Content -->
					<table style="width: 100%;max-width: 600px;margin: 0 auto;padding: 0;text-align: center;background: transparent;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">
						<tr>
							<td>				
								<tr>
									<td valign="middle" style="background-image: url(https://vastreach.com/static_assets/email/summer_v1/text-bg.jpg);background-position: center center !important;background-size: cover !important;text-align: center;">
										<table border="0" cellpadding="0" cellspacing="0" width="100%" style="border-spacing: 0;">
											<tr>
												<td valign="middle" style="text-align: center;padding: 40px;">
													<span style="font-size: medium;color: #ffffff;padding: 0;margin:0;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">Optional text box to provide more details about your summer product, service or promotion. If the additional text isn’t needed, just delete it.</span>
												</td>
											</tr>
										</table>
									</td>
								</tr>
							</td>
						</tr>
					</table> 				
					<!-- Dynamic WYSIWYG Content -->	
				</td>    
			</tr>    

			<tr>
				<td class="vastreach-sections" data-vast-editor="paragraph">
					<!-- Dynamic WYSIWYG Content -->
					<div style="max-width: 600px;margin: 0 auto;padding: 10px 20px;text-align: center;background: transparent;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">				
						<h2 style="font-weight: 500;color: #000000;padding: 0;margin: 0;"><strong><span style="font-size: medium;font-family: Arial, Helvetica, sans-serif;">Product Promotion or Sale</span></strong></h2>
						<span style="font-size: medium;color:#000000;padding: 0;margin:0;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">Highlight a product, product line or service here that you want to promote.</span>
					</div> 				
					<!-- End of Dynamic WYSIWYG Content -->
				</td>	
			</tr>
			
			<tr>
				<td class="vastreach-sections" data-vast-editor="button">
					<!-- Dynamic WYSIWYG Content -->
					<div style="max-width: 600px;margin: 0 auto 0;padding: 10px 0;text-align: center;background: transparent;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">
						<p style="text-align: center;margin:0;">
							<a data-button-text="Start now" data-button-url="https://www.vastreach.com" data-button-color="#ffffff" data-button-background-color="#00bfaf" href="#" target="_blank">
								<button style="color: #ffffff; background-color: #00bfaf;border: 0; padding: 15px 25px; margin: 0; border-radius: 0.3rem; cursor: pointer;"><strong>Start Now</strong></button>
							</a>
						</p>
					</div>			
					<!-- End of Dynamic WYSIWYG Content -->
				</td>	
			</tr>   		

			<tr>
				<td class="vastreach-sections" data-vast-editor="paragraph">
					<!-- Dynamic WYSIWYG Content -->
					<div style="max-width: 600px;margin: 0 auto;padding: 10px 0;text-align: center;background: transparent;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">				
						<hr>
					</div> 				
					<!-- End of Dynamic WYSIWYG Content -->
				</td>									
			</tr>	  

			<tr>
				<td class="vastreach-sections" data-vast-editor="social-media">
					<!-- Dynamic WYSIWYG Content -->
					<table style="margin: 0 auto;background: transparent;" border="0" cellpadding="0" cellspacing="0" align="center">
						<tr>
							<td width="600" align="center">
								<table style="margin: 20px 0 20px 0;">
									<tr>
										<td align="center"> <a data-social-media="facebook" href="https://www.facebook.com/" target="_blank"><img src="https://vastreach.com/static_assets/facebook.png" border="0" style="background-color: #00bfaf; padding: 4px; border-radius:28px;" /></a> </td>
										<td align="center"> <a data-social-media="instagram" href="https://www.instagram.com/" target="_blank"><img src="https://vastreach.com/static_assets/instagram.png" border="0" style="background-color: #00bfaf;padding: 4px; border-radius:28px;" /></a> </td>
										<td align="center"> <a data-social-media="twitter" href="https://twitter.com/" target="_blank"><img src="https://vastreach.com/static_assets/twitter.png" border="0" style="background-color: #00bfaf;padding: 4px; border-radius:28px;" /></a> </td>
									</tr>
								</table>
							</td>
						</tr>
					</table>
					<!-- End of Dynamic WYSIWYG Content -->							
				</td>	
			</tr>
		</table>
		<!-- End of Wrapper -->		
	</div>		
</div>		
</body>	
</html>`,
}
